import type { AgenticQuestionCategory, QuestionBankCategoryFromAPI } from '../AskAsperAgentic.types';

/** Transform API format question bank categories to AgenticQuestionCategory[] */
export function transformQuestionBankCategories(
    apiCategories: QuestionBankCategoryFromAPI[],
): AgenticQuestionCategory[] {
    return apiCategories
        .filter((cat) => cat?.Category != null && String(cat.Category).trim() !== '')
        .map((cat) => {
            const categoryStr = String(cat.Category);
            const id = categoryStr.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '');
            return {
                id,
                name: categoryStr,
                displayName: categoryStr,
                description: '',
                questions: (cat.Questions ?? []).map((q) => ({
                    id: String(q?.QuestionID ?? ''),
                    text: q?.Question ?? '',
                    QuestionID: q?.QuestionID,
                    Question: q?.Question ?? '',
                })),
            };
        });
}
